// prettier-ignore
const SingleModuleLoader = {
	Init: function () {
		window.singleModules = window.singleModules || {}
		document.addEventListener('DOMContentLoaded', () => {
			SingleModuleLoader.Config.forEach((moduleToLoad) => {
				SingleModuleLoader.LazyLoadModule(moduleToLoad, () => {
					let rootPathPrefix =
						SingleModuleLoader.GetCurrentScriptHostname().startsWith(
							'localhost'
						)
							? ''
							: '//' + SingleModuleLoader.GetCurrentScriptHostname() + '/html' //remove HTML from path with local markup development
					let customizedVersion = SingleModuleLoader.ExpiryTime(300)
					SingleModuleLoader.AppendScript(
						SingleModuleLoader.GetModulePath(
							rootPathPrefix + '/scripts/single-modules/',
							moduleToLoad.name,
							moduleToLoad.path,
							customizedVersion
						),
						() => {
							try {
								window.singleModules[moduleToLoad.name].Init()
							} catch (e) {
								console.warn(
									'[lazyLoad] module error:',
									moduleToLoad.name,
									e
								)
							}
						}
					)
				})
			})
		})
	},
	ExpiryTime(timeInSeconds) {
		const currentTimeInSeconds =
			Math.floor(Date.now() / 1000 / timeInSeconds) * timeInSeconds
		return currentTimeInSeconds
	},
	GetCurrentScriptHostname: function () {
		var hostnames = [
			'tvnoviny.sk',
			'mobile-app.tvnoviny.sk',
			'app.tvnoviny.sk',
		]
		if (hostnames.includes(window.location.host)) {
			return 'newtvnoviny.markiza.sk'
		} else {
			return window.location.host
		}
	},
	Config: [
		{
			selector: '.js-custom-select-ajax',
			name: 'ArticleAjax',
			version: '1.0.0',
		},
		{
			selector: '.js-search-autocomplete',
			name: 'AutoComplete',
		},
		{
			selector:
				'.js-article-carousel, .js-article-carousel-related-content, .js-custom-select-ajax-content-carousel, .js-article-carousel-xl, .js-article-live-carousel, .js-article-live-carousel-xl, .js-program-live-carousel, .js-program-live-hp-carousel, .js-carousel-election-research, .js-carousel-election-parties, .js-gallery-carousel, .js-brickmenu-carousel, .js-weather-carousel, .js-nova-results-carousel, .js-nova-results-shows-carousel',
			name: 'Carousel',
		},
		// {
		//     selector: '.js-disclosure',
		//     name: 'Disclosures'
		// },
		{
			selector: '.js-election',
			name: 'Election',
		},
		{
			selector: '.c-green-week',
			name: 'GreenWeek',
		},
		{
			selector: '.js-forms-iframe',
			name: 'Iframes',
		},
		{
			selector: '[data-playtime]',
			name: 'Playtime',
		},
		{
			selector: '.js-related-wrapper',
			name: 'RelatedBoxFloating',
			version: '1.0.0',
		},
		{
			selector: '.js-horizontal-scrollbar',
			name: 'Scrollbar',
		},
		{
			selector: '.js-sport-special-module',
			name: 'SportSpecial',
		},
		{
			selector: '.c-player.-live',
			name: 'StreamDetektor',
		},
		{
			selector: '.c-tnlive',
			name: 'TnLive',
		},
		// {
		// 	selector: '.c-player.-live-inline',
		// 	name: 'TnLiveSmall',
		// },
		// {
		// 	selector: '.c-tnlive .-hero',
		// 	name: 'TnLiveChanger',
		// },
		{
			selector: '#js-ski-resorts-vue',
			name: 'SkiResorts',
			path: 'skiResorts/main',
		},
		{
			selector: '.horoscopes-wrapper',
			name: 'Horoscopes',
		},
		{
			selector: '.swiper-pagination-current',
			name: 'Waypoints',
		},
		{
			selector: '.js-datepicker, .js-custom-select, .js-parsley',
			name: 'Form',
		},
		{
			selector: '.c-euro24',
			name: 'euro24',
		},
		{
			selector: '.c-volby.usa24',
			name: 'usa24',
		},
	],
	LazyLoadModule: function (config, callback, forcedRootMargin) {
		const selector = config.selector
		const name = config.name
		const loadedModules = new Set()

		const targets = document.querySelectorAll(selector)

		if (!targets.length) {
			return
		}
		targets.forEach((target) => {
			const rect = target.getBoundingClientRect()
			const distance = parseInt(rect.top - window.innerHeight)
			const rootMargin =
				forcedRootMargin ||
				Math.max(parseInt((distance * 2) / 3), 1500) + 'px'
			const options = {
				root: null,
				rootMargin: rootMargin,
				threshold: 0,
			}

			var observer = new IntersectionObserver(function (
				entries,
				observer
			) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting && !loadedModules.has(name)) {
						loadedModules.add(name)
						observer.unobserve(entry.target)
						callback()
					}
				})
			},
			options)

			observer.observe(target)
		})
	},
	AppendScript: function (path, callback) {
		const script = document.createElement('script')
		script.src = path
		script.defer = true
		script.onload = callback
		document.head.appendChild(script)
	},
	GetModulePath: function (root, name, path, version) {
		const end = '.js' + (version ? '?v=' + version : '')
		if (!path) {
			return root + name + end
		}
		return root + path + end
	},
}

export default SingleModuleLoader
